import { useSceneEntities } from "@/stores/SceneEntities";
export function useAssetTub3053Whirlpool(payload, viewport) {
  const sceneEntities = useSceneEntities();
 
  let assets = ["elite_3053_button_2","elite_3053_jets_whirlpool"];

  assets.forEach((value) => {
    let asset = sceneEntities.configuratorView.viewportComponent.getViewportAsset(value);
    asset.enabled = payload.enabled;
    viewport.setEnabled(asset);
  });

 
}
